// @ts-nocheck
/**
* ATTENTION!
* @generated THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
*/

import * as Types from '../schema';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
const defaultOptions = {} as const;
export type ResumeAiChatSessionMutationVariables = Types.Exact<{
  sessionId: Types.Scalars['ID']['input'];
}>;


export type ResumeAiChatSessionMutation = { __typename?: 'Mutation', resumeAiChatSession: { __typename?: 'AiChatSession', id: string, workspaceId: string, scopeType: Types.AiChatScopeType, status: Types.AiChatSessionStatus, scopeDocumentCollectionId?: string | null, title: string, createdAt: any, updatedAt: any } };


export const ResumeAiChatSessionDocument = gql`
    mutation ResumeAiChatSession($sessionId: ID!) {
  resumeAiChatSession(sessionId: $sessionId) {
    id
    workspaceId
    scopeType
    status
    scopeDocumentCollectionId
    title
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useResumeAiChatSessionMutation__
 *
 * To run a mutation, you first call `useResumeAiChatSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeAiChatSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeAiChatSessionMutation, { data, loading, error }] = useResumeAiChatSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useResumeAiChatSessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResumeAiChatSessionMutation, ResumeAiChatSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResumeAiChatSessionMutation, ResumeAiChatSessionMutationVariables>(ResumeAiChatSessionDocument, options);
      }
export type ResumeAiChatSessionMutationHookResult = ReturnType<typeof useResumeAiChatSessionMutation>;
export type ResumeAiChatSessionMutationResult = ApolloReactCommon.MutationResult<ResumeAiChatSessionMutation>;